import { render, staticRenderFns } from "./QREditItem_Ap.vue?vue&type=template&id=040c04f0&scoped=true"
import script from "./QREditItem_Ap.vue?vue&type=script&lang=js"
export * from "./QREditItem_Ap.vue?vue&type=script&lang=js"
import style0 from "./QREditItem_Ap.vue?vue&type=style&index=0&id=040c04f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040c04f0",
  null
  
)

export default component.exports